import {
  apiBaseUrlsWithoutApiNameSpace,
  // deletee,
  get,
  post,
} from "./index";

export const getPlanListing = (params) => {
  const request = {
    subUrl: `/direct_clinicians/subscription_plans_listing`,
    params,
  };
  return get(request);
};

export const createCharges = (params) => {
  let currentEnv = process.env.REACT_APP_ENV;
  let baseUrl = apiBaseUrlsWithoutApiNameSpace[currentEnv];

  const request = {
    subUrl: `${baseUrl}/create_charges`,
    params,
    isOnlyURL: true,
  };
  return get(request);
};

export const geClinicianSubscribedtPlanAPI = (params) => {
  // console.log("params=>", params);
  // let formData = new FormData();
  // formData.set("vantage_subscription_plan_id", params.id);
  const request = {
    subUrl: `/direct_clinicians/show_subscription_details`,
    params,
  };
  return get(request);
};

export const addAddvMindsCancelSubscriptionAPI = (params) => {
  // let formData = new FormData();

  // formData.set("add_vantage_corporate_id", data.add_vantage_corporate_id);
  // formData.set("direct_clinician_id", data.direct_clinician_id);

  const request = {
    subUrl: `/direct_clinicians/cancel_subscription`,
    params,
  };

  return post(request);
};
export const addAddvMindsUpgradeSubscriptionAPI = (data) => {
  let formData = new FormData();

  formData.set(
    "vantage_subscription_plan_id",
    data.vantage_subscription_plan_id
  );
  formData.set("direct_clinician_id", data.direct_clinician_id);

  const request = {
    subUrl: `/direct_clinicians/upgrade_plan`,
    data: formData,
  };

  return post(request);
};
